import { forEach, forOwn, clone, toArray, sortBy} from 'lodash';

import { OwnedObject } from 'gear';

import { Xml } from './xml';

export const Metadata = OwnedObject.extend({ typeName: 'Metadata',

  get isEmpty() {
    return this.map.size === 0;
  },

  set( key, value ) {
    this.map.set(key,value);
  },

  get( key ) {
    return this.map.get(key);
  },

  delete( key ) {
    this.map.delete(key);
  },

  has( key ) {
    return this.map.has(key);
  },

  keys() {
    return this.map.keys();
  },

  forEach( func ) {
    this.map.forEach(func);
  },

  clone() {
    const metadata = new Metadata();
    metadata.map = clone(this.map);
    return metadata;
  },

  setupXml( node ) {
    var keyValues = toArray(this.map);
    keyValues.sort(function(a, b) { return a[0] > b[0]; });
    for ( var i = 0 ; i< keyValues.length; i++ ) {
      var k = keyValues[i];
      if ( k !== undefined && k.length > 0 )
        node.setAttribute( Xml.toXmlCase(k[0]), k[1] );
    }
  },

  init( config ) {
    this.callParent(config);
    this.map = new Map();
    forOwn( config, (value,key) => {
      this.set(key,value);
    });
  }
});

Metadata.parseXml = function(node,owner) {
  const p = {};
  forEach( node.attributes, ({ name, value }) => {
    p[ Xml.toObjectCase(name) ] = value;
  });
  forEach( owner._ignoreAttributes, name => {
    delete p[name];
  });
  forEach( owner.Properties, (c,name) => {
    const delName = c.tag ? Xml.toObjectCase(c.tag) : name;
    delete p[delName];
  });
  const metadata = new Metadata(p);
  metadata.owner(owner);
  return metadata;
};

export default Metadata;



/** WEBPACK FOOTER **
 ** ./src/cdl/util/metadata.js
 **/